<template>
    <div class="refund-dialog refund-dialog-list">
        <el-dialog
            class="form-dialog"
            title="退款申请"
            :visible.sync="refundShowList"
            :before-close="refundCell"
            width="40%"
        >
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="70px"
                class="demo-ruleForm"
            >
                <el-form-item label="银行账号" prop="account" class="label-form">
                    <el-select v-model="ruleForm.account" placeholder="请在此输入银行账户" value-key="item" :disabled="true">
                        <el-option
                            v-for="item in accountOptions"
                            :key="item.bankCode"
                            :label="item.bankAccount"
                            :value="item"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开户行" prop="bankName">
                    <el-input v-model="ruleForm.bankName" placeholder="开户行" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="账户名称" prop="bankAccountName">
                    <el-input v-model="ruleForm.bankAccountName" placeholder="账户名称" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="退款金额" prop="refundAmount">
                    <el-input :disabled="true" v-model="ruleForm.refundAmount" placeholder="请输入退款金额"></el-input>
                </el-form-item>
                <el-form-item label="附件上传" prop="imageList" class="refun-data">
                    <el-upload :disabled="true" class="upload-demo-name refun-left" action
                        accept=".pdf" multiple :limit="5" :file-list="fileList">
                        <el-button :disabled="true" size="mini" type="primary">点击上传</el-button>
                    </el-upload>
                    <div class="refun-right">
                        <el-row :gutter="20" v-for="(item, index) in imageList" :key="index">
                            <el-col :span="18"><div>{{item.substr1}}</div></el-col>
                            <el-col :span="6" class="download"><span @click="downloadList(item)">下载</span></el-col>
                        </el-row>
                    </div>
                </el-form-item>
                <el-form-item label prop="electronicSignature">
                    <div class="contens">
                        <el-button :disabled="isDisabled" :loading="isLoading">
                            <i class="el-icon-check confirm" v-if="isCondition"></i>电子签章
                        </el-button>
                        <div class="contens-tip">
                            提示：退款前请查阅
                            <span class="hyperlink disabled" >《退款申请函》</span>，查阅后点击电子签章进行盖印再提交申请。
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="refundCell">取 消</el-button>
                <el-button type="primary" @click="refundOk('ruleForm')">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components: { },
    props: {
        refundShowList: {
            type: Boolean,
            default: false
        },
        balance: {
            type: Number
        },
        dataBalanceObj: {
            type: Object
        },
        dataId: {
            type: String
        },
        dataUrl: {
            type: String
        },
        ruleFormObj: {
            type: Object
        },
        uploadLookData: {
            type: Array
        }
    },
    data() {
        return {
            imageList: [],
            fileList: [],
            isDisabled: false,
            isLoading: false,
            isCondition: false,
            ruleForm: {
                refundAmount: '',
                account: '',
                bankName: '',
                bankAccountName: '',
                electronicSignature: ''
            },
            rules: {},
            accountOptions: [],
            value: ''
        };
    },
    mounted() {
        this.ruleForm.account = this.ruleFormObj.accountName;
        this.ruleForm.bankName = this.ruleFormObj.bankAccount;
        this.ruleForm.bankAccountName = this.ruleFormObj.bankAccountName;
        this.ruleForm.refundAmount = this.ruleFormObj.applyAmt;
        this.isDisabled = true;
        if (this.ruleFormObj.esignature && this.ruleFormObj.esignature === '1') {
            this.isCondition = true;
        }
        this.imageList = this.uploadLookData;
    },
    methods: {
        downloadList(item) {
            window.open(item.substr3);
        },
        refundOk(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$emit('refundOk', { state: true, data: this.ruleForm, applyNo: this.ruleFormObj.applyNo });
                } else {
                    this.$emit('refundOk', { state: false, form: valid, data: {} });
                    return false;
                }
            });
        },
        refundCell() {
            this.$emit('refundCell', '');
        }
    }
};
</script>

<style lang="less">
@import './refundDialog.less';
.refund-dialog{
    .disabled {
        pointer-events: none;
        cursor:not-allowed;
        opacity: 0.6;
    }
}
.refund-dialog-list{
    .uploa-data-list{
        margin-bottom: 10px;
    }
    .download:hover{
        color: #00a9ac;
        cursor: pointer;
    }
    .contens-tip{
        margin-left: 10px;
    }
}
</style>